import { render, staticRenderFns } from "./relayDetailDialog.vue?vue&type=template&id=6a38ec2e&"
import script from "./relayDetailDialog.vue?vue&type=script&lang=js&"
export * from "./relayDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports